import { actionCreatorFactory } from "typescript-fsa";


const actionCreator = actionCreatorFactory("MYFooter");

const resetData = actionCreator<{version:string}>("MYFooter_RESETDATA");

 export const FooterThingyActions = { resetData}


